<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter :paso="config.pasos.contrato.paso" />
      <wrap-container v-if="urlContract.length > 0" class="cascade w50">
        <form-validator>
          <wrap-container>
            <p
              class="titulo p32 medium oscuro"
              v-safe-html="config.pasos.contrato.titulo"
            />
          </wrap-container>
          <wrap-container>
            <div class="subtitulo">
              <p class="titulo oscuro">
                Para poder empezar a utilizar los productos de tu Caja de
                Ahorro, te pedimos que leas y aceptes
                <span v-if="urlContract.length > 1"
                  >los siguientes contratos</span
                >
                <span v-else>el siguiente contrato</span>
                <span v-for="(item, $index) in urlContract" :key="$index">
                  <a
                    @click="mostrarContrato(item.urlPDFBase64, $index)"
                    class="link-contract"
                    target="_blank"
                    rel="noopener"
                  >
                    contrato{{ $index + 1
                    }}<span v-if="$index + 1 < urlContract.length">, </span>
                  </a> </span
                >.
              </p>
            </div>
          </wrap-container>
          <wrap-container>
            <check-box
              label="Acepto el contrato digital"
              :required="true"
              analytics-name="acepto el contrato digital"
              v-model="model.firmaContrato"
            />
          </wrap-container>
          <step-navigator
            v-model="model"
            store-action="DO_CONTRATO"
            :router-push="false"
            analytics-name="finalizar"
          />
        </form-validator>
      </wrap-container>
      <wrap-container v-if="urlContract.length == 0" class="cascade w50">
        <form-validator>
          <wrap-container>
            <p class="titulo p32 medium oscuro">Firma de contratos</p>
          </wrap-container>
          <wrap-container>
            <div class="subtitulo">
              <p class="titulo oscuro">
                Para poder empezar a utilizar los productos de tu Caja de
                Ahorro, te pedimos que accedas a tu cuenta de Home Banking y
                firmes los contratos pendientes.
              </p>
            </div>
          </wrap-container>
          <step-navigator
            v-model="model"
            store-action="DO_CONTRATO_PENDING_SIGNATURE"
          />
        </form-validator>
      </wrap-container>
      <wrap-container class="cascade w50"></wrap-container>
    </div>
    <modal-component
      :label="infoContrato.titulo"
      :show="showModal"
      :buttonLabel="infoContrato.boton"
      @close="showModal = false"
      @aceptar="windowContrato"
      analyticsNameSalesButton="descargar"
      analyticsNameLevel2="contrato"
      :analyticsModule="contratoElegido"
      :analyticsSubmodule="contratoElegido"
    >
      <pdf-viewer :src="infoContrato.url" />
    </modal-component>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepCounter from "@/components/core/StepCounter";
import StepNavigator from "@/components/core/StepNavigator";
import CheckBox from "@/components/core/custom/CheckBox";
import ModalComponent from "@/components/core/ModalComponent.vue";
import PdfViewer from "@/components/core/custom/PdfViewer";

export default {
  name: "Contrato",
  components: {
    WrapContainer,
    FormValidator,
    StepCounter,
    StepNavigator,
    CheckBox,
    ModalComponent,
    PdfViewer
  },
  data() {
    return {
      model: this.$store.getters.getContrato(),
      urlContract: this.$store.getters.getContractsPdf(),
      infoContrato: { titulo: "Contrato", url: "", boton: "Descargar" },
      showModal: false,
      contratoElegido: null
    };
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getContractsPdf,
      urlContract => {
        this.urlContract = urlContract;
      },
      { immediate: true }
    );
  },
  created() {
    let payload = {
      numeroTramite: this.$store.getters.getNumeroTramite(),
      randomKey: this.$store.getters.getRandomKey()
    };
    this.$store.dispatch("DO_SEARCH_CONTRACT", payload);
  },
  methods: {
    mostrarContrato(url, index) {
      this.contratoElegido = "contrato" + (index + 1);
      this.infoContrato.url = url;
      this.showModal = true;
    },
    windowContrato() {
      window.open(this.infoContrato.url);
    }
  }
};
</script>

<style scoped>
.container {
  margin-bottom: 250px;
}
.cobranding-logo-header {
  top: 36px;
}

.container .acept-contrat {
  margin: 40px 0 100px 0;
}

.link-contract {
  color: #0070bd;
  text-decoration: none;
  font-size: 14px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

@media screen and (max-width: 600px) {
  .container {
    margin-bottom: 100px;
  }
  #titulo {
    font-size: 26px;
  }
}
</style>
